import { Tween } from "tweedle.js";
import { RespinIndex } from "../config/GlobalVariableConfig";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { spinData } from "../server/getServerResposesFun";


export function isFireFox(): boolean {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    if (/firefox/i.test(ua)) return true;

    const uaData = (navigator as any).userAgentData;
    if (uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    if (uaData?.platform === 'Android' && uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    return typeof (window as any).InstallTrigger !== 'undefined';
}

export async function wait(ms: number) {
    return new Promise((resolve) => {
        new Tween({})
            .delay(ms)
            .onAfterDelay(resolve) // Resolve the promise when delay ends
            .start();
    });
}

/**
 * Detects if the current device is running iOS (iPhone, iPad, or iPod).
 */
export const IS_IOS = (): boolean => {
    const { userAgent, maxTouchPoints } = window.navigator;
    const isStandardIOS = /iPhone|iPad|iPod/i.test(userAgent);

    const isModerniPad =
        userAgent.includes("Macintosh") &&
        maxTouchPoints > 1;

    return isStandardIOS || isModerniPad;
};

export function getCoordinates(offset: number, isStartFromZero: boolean = true) {
    const adjustedOffset = (isStartFromZero) ? offset : offset - 1;
    const row = Math.floor(adjustedOffset / 5);
    const col = adjustedOffset % 5;
    return { row, col };
}

export function customSortColumnWise(arr: number[][]) {
    arr.sort((a, b) => {
        if (a[0] !== b[0]) {
            return a[0] - b[0];
        }
        return a[1] - b[1];
    });
    return arr;
}

export function getJackpotEntryByValue(targetValue: number) {
    let list: Record<number, number>[];

    if (spinData?.respins[RespinIndex.value]?.type === "fs_reveal") {
        list = GameConstants.FREESPIN_SCARAB_REWARD;
    } else {
        list = GameConstants.BASEGAME_SCARAB_REWARD;
    }

    const index = list.findIndex(item => Object.values(item)[0] === targetValue);

    if (index === -1) return null;

    const item = list[index];
    const key = Number(Object.keys(item)[0]);
    const value = item[key];

    return { index, key, value };
}

export function getJackpotEntryByIndex(index: number) {
    let list: Record<number, number>[];

    if (spinData?.respins[RespinIndex.value]?.type === "fs_reveal") {
        list = GameConstants.FREESPIN_SCARAB_REWARD;
    } else {
        list = GameConstants.BASEGAME_SCARAB_REWARD;
    }
    const item = list[index];

    const key = Number(Object.keys(item)[0]);
    const value = item[key];

    return { index, key, value };
}
